import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeSubMenu: null,
};

const menuSlice = createSlice({
  name: "menu",
  initialState: initialState,
  reducers: {
    setActiveSubMenu: (state, action) => {
      state.activeSubMenu = action.payload; // Mutate state directly
    },
  },
});

export default menuSlice.reducer;

export const { setActiveSubMenu } = menuSlice.actions;
